module.exports = __webpack_public_path__ + "img/reception-1.9ad54419.svg";